"use client";

import { useState } from "react";
import {
  Command,
  // CommandEmpty,
  // CommandGroup,
  CommandInput,
  // CommandItem,
  // CommandList,
} from "../../components/ui/command";
import { useTranslation } from "react-i18next";
import { indexStore } from "../../store/indexStore";
import { IMG_URl } from "../../common/img_url";
import Visibility from "../utils/Visibility";
// import { useNavigate } from "react-router-dom";
import ProductModel from "../../Models/PorductModel";
import { useParams } from "react-router-dom";

function SearchField() {
  const { name, fetchSearchProducts, searchProducts } = indexStore();
  const [query, setQuery] = useState("");

  const params = useParams();
  const showDropdown = query.length > 0;
  const { t } = useTranslation();
  const loading = false;
  const handleClick = (item: ProductModel) => {
    window.location.replace(
      `/${params.domain}/${params.branch_id}/${item.menu_id}/${item.id}`
    );
    setQuery("");
  };
  const handleChange = (search: string) => {
    setQuery(search);
    if (search !== "") {
      const SearchParams = {
        word: search,
        branch_id: params.branch_id,
        domain: params.domain,
      };
      fetchSearchProducts(SearchParams);
    }
  };

  return (
    <div className="w-full mx-auto relative">
      <Command className="rounded-full border-2 border-border shadow-md hover:shadow-lg focus-within:border-primary transition-all duration-300">
        <CommandInput
          className="w-full rounded-full outline-none px-4 py-2.5 md:py-3 text-sm md:text-base bg-background text-foreground placeholder:text-muted-foreground"
          placeholder={t("gloabl.search")}
          value={query}
          onValueChange={handleChange}
        />
        <Visibility visible={showDropdown}>
          <div className="absolute top-12 md:top-14 rounded-xl z-50 mt-1 w-full bg-background border-2 border-border shadow-xl rounded-md max-h-64 overflow-auto">
            {loading && (
              <div className="p-3 text-sm text-muted-foreground text-center">
                {t("gloabl.loading")}
              </div>
            )}

            {!loading && searchProducts.length === 0 && (
              <div className="p-3 text-sm text-muted-foreground text-center">
                {t("gloabl.noResult")}
              </div>
            )}

            {!loading &&
              searchProducts.length > 0 &&
              searchProducts.map((product) => (
                <div
                  key={product.id}
                  className="flex items-center gap-3 p-3 hover:bg-muted cursor-pointer transition-colors duration-200 border-b border-border/50 last:border-b-0"
                  onClick={() => handleClick(product)}
                >
                  <img
                    src={`${IMG_URl}/${product.image}`}
                    alt={product.name_en}
                    className="w-12 h-12 md:w-14 md:h-14 object-cover rounded-lg flex-shrink-0"
                  />
                  <span className="text-sm md:text-base text-foreground font-medium flex-1 min-w-0 truncate">
                    {String(product[name as keyof ProductModel] || "")}
                  </span>
                </div>
              ))}
          </div>
        </Visibility>
      </Command>
    </div>
  );
}

export default SearchField;
